import json from "@/data/copy/language-suggestion.json";
import regions from "@/data/locale-regions.json";
import { createCopyGetter, localizeCopy } from "@/lib/localize-copy";
import type { Lang } from "@/lib/types";

export const getLanguageSuggestionCopy = createCopyGetter(json);

export function getLanguageSuggestionCountry(country: string | null, lang: Lang): string | null {
  const region = country ? regions.regions[country as keyof typeof regions.regions] : undefined;
  return region ? localizeCopy(region.name, lang) : null;
}
